import { ChampionRankingStatsNormal } from "components/Champions/ChampionRankingStats";
import { useChampionProfileContext } from "@ugg/shared/components/Champions/ChampionProfileContext";
import { ChampionProfilePageError } from "@ugg/shared/components/Champions/ChampionProfilePageError";
import Skills from "@ugg/shared/components/Champions/pages/Overview/Skills";
import { ArenaItems } from "@ugg/shared/components/Champions/pages/Arena/ArenaItems";
import { ArenaSynergies } from "@ugg/shared/components/Champions/pages/Arena/ArenaSynergies";
import { ArenaAugments } from "@ugg/shared/components/Champions/pages/Arena/ArenaAugments";
import { ArenaPrismaticItems } from "@ugg/shared/components/Champions/pages/Arena/ArenaPrismaticItems";
import { getArenaModeType } from "@ugg/shared/utils/queue-type-helpers";
import { useOverview } from "@ugg/shared/components/Champions/pages/Overview/overview-helpers";

const ArenaBuild = () => {
  const { championId } = useChampionProfileContext();
  const { filters, fetchingData, rankingStats, championOverview } = useOverview({ ssr: true });
  const { patch, queueType, opp } = filters;

  if (fetchingData) {
    return (
      <div className="champion-recommended-build">
        <div className="spinthatshit-loader">
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  const {
    rec_starting_items,
    rec_core_items,
    rec_skills,
    rec_skill_path,
    rec_skill_evolve_path,
    item_options_1,
    item_options_2,
    item_options_3,
    consumable_options,
    prismatic_options,
    arena_synergies,
    arena_augments,
  } = championOverview || {};

  const minDataExists = rec_starting_items && rec_core_items && rec_skills && rec_skill_path;
  // item_options_1 &&
  // item_options_2 &&
  // item_options_3;

  if (!minDataExists) {
    return <ChampionProfilePageError message="No data found. Please try again or change filters." />;
  }

  return (
    <div className="champion-recommended-build ">
      <div className="flex flex-wrap gap-[24px]">
        {rankingStats && <ChampionRankingStatsNormal className="flex-1" rankingStats={rankingStats} queueType={queueType} />}
      </div>
      <div className="arena-synergies-and-augments mt-[18px] gap-[1px] flex max-sm:flex-col max-sm:gap-[12px]">
        <ArenaSynergies
          className="flex-1 rounded-tl-[3px] rounded-bl-[3px] max-sm:rounded-[3px]"
          championId={championId}
          data={arena_synergies || []}
          patch={patch}
          arenaModeType={getArenaModeType(patch)}
        />
        <ArenaAugments
          className="flex-1 rounded-tr-[3px] rounded-br-[3px] max-sm:rounded-[3px]"
          championId={championId}
          data={arena_augments || []}
          patch={patch}
        />
      </div>
      <ArenaPrismaticItems className="mt-[12px]" championId={championId} items={prismatic_options || []} patch={patch} />
      <Skills
        championId={championId}
        skillPriority={rec_skills}
        skillPath={rec_skill_path}
        evolutionPath={rec_skill_evolve_path}
      />
      <ArenaItems
        startingItems={rec_starting_items}
        coreItems={rec_core_items}
        items1={item_options_1 || []}
        items2={item_options_2 || []}
        items3={item_options_3 || []}
        consumables={consumable_options || []}
        patch={patch}
      />
    </div>
  );
};

export default ArenaBuild;
